import { Box, Button, Theme, Typography, createStyles, makeStyles, withWidth } from '@material-ui/core'
import React from 'react'
import { getIsMobileApp } from '../../utils/mobileApp';

const useStyles = makeStyles((theme: Theme) => createStyles({
  cover: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  advancedButton: {
    background: '#0042C1',
    color: 'white',
    fontFamily: "Inter",
    width: '60%',
    marginBottom: 12,
  },
  title: {
    color: 'white',
    textAlign: 'center',
    lineHeight: '130%',
    opacity: '70%',
    fontFamily: "Inter",
    margin: '18px 0',
  },
  imgWrapper: {
    maxHeight: 45,
    maxWidth: 200,
    marginRight: 24,
    '& img': {
      height: '100%',
      width: '100%',
    }
  },
})
);

const MobileCover = ({ children, width }) => {
  const classes = useStyles();
  const isMobileApp = getIsMobileApp();
  const [displayChildren, setDisplayChildren] = React.useState(false);


  const handleClick = () => {
    setDisplayChildren(true);
    localStorage.setItem("optinToMobile", "true");
  }

  React.useEffect(() => {
    const optedIntoMobile = localStorage.getItem('optinToMobile');
    if(optedIntoMobile){
      setDisplayChildren(true)
    }
  }, [])
  return (
    <Box>
      {
        width === 'xs' && !displayChildren && !isMobileApp && (
          <Box bgcolor='#031630' height='100%' width='100%' zIndex='2000' position='absolute' className={classes.cover}>
            <Box className={classes.imgWrapper}>
              <img
                src={`${process.env.PUBLIC_URL}/images/logo.png`}
                alt=""
              />
            </Box>
            <Typography variant='h5' className={classes.title}>Stokastic Sims is only supported on desktop devices.</Typography>
            <Button variant='contained' className={classes.advancedButton} href='https://stokastic.com'>Stokastic.com</Button>
            <Button variant='text' onClick={handleClick} style={{ color: 'white',}}>Continue Anyways</Button>
          </Box>
        )
      }
      {
        (width !== 'xs' || displayChildren || isMobileApp) && (
          <>
            { children }
          </>
        )
      }
    </Box>
  )
}

export default withWidth()(MobileCover);